export default __webpack_public_path__ + "static/media/frog_R1_C1.49f38745.png";